import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { SCSelect } from 'rollup-allspark';
import { DEFAULT_ALL_PAGE_SIZE, DEFAULT_PAGE_NO } from '../../config';
import usePrinter from '../../hooks/usePrinter';
import { isEmpty } from '../../utils';
import { makeSelectGlobalProperty } from '../App/selectors';
import { getList, updateEntity } from './actions';
import { BRANCH_LIST, BRAND_LIST } from './sagaMap';
import { makeSelectProperty } from './selector';

const Filters = ({
  branches,
  businessList,
  getBranches,
  getBrands,
  getPrinterProfiles,
  selectedBranch,
  selectedBusiness,
  updateField,
}) => {
  const { getProfiles } = usePrinter({
    getPrinterProfiles,
    selectedBranch,
    updateField,
  });
  const onBizSelected = biz => {
    if (!isEmpty(biz)) {
      getBranches({
        ...BRANCH_LIST,
        params: {
          page: DEFAULT_PAGE_NO,
          size: DEFAULT_ALL_PAGE_SIZE,
          filterByBusiness: biz.id,
        },
      });
    }

    updateField({
      branches: [],
      brands: [],
      categories: [],
      checkedCategories: [],
      checkedItems: [],
      isLoading: false,
      isLoadingProfiles: false,
      isSaving: false,
      items: [],
      itemSearchKey: '',
      menus: [],
      profiles: [],
      selectedBranch: null,
      selectedBrand: null,
      selectedBusiness: biz,
      selectedFilterCategory: null,
      selectedFilterMenu: null,
      selectedProfile: null,
    });
  };

  const onBranchSelected = loc => {
    getBrands({
      ...BRAND_LIST,
      params: {
        filterByBusiness: loc.business_id,
        filterByBranch: loc.id,
      },
      callbackFn: list => {
        if (!isEmpty(list) && list.length === 1) {
          const [ob] = list;

          updateField({
            selectedBrand: ob,
          });
        }
      },
    });

    getProfiles(loc);

    updateField({
      categories: [],
      checkedCategories: [],
      checkedItems: [],
      items: [],
      itemSearchKey: '',
      menus: [],
      profiles: [],
      selectedBranch: loc,
      selectedBrand: null,
      selectedFilterCategory: null,
      selectedFilterMenu: null,
      selectedProfile: null,
    });
  };

  return (
    <div className="flex justify-between bg-white border border-grey rounded-lg p-4">
      <div className="text-lg flex items-center">Printer Profiles</div>
      <div className="flex gap-x-4">
        <SCSelect
          searchable
          options={businessList}
          customLabel={b => `${b.id}. ${b.title}`}
          searchAbleAttribute={['title', 'id']}
          trackBy="id"
          placeholder="Select a Business"
          className="w-64"
          onSelect={onBizSelected}
          value={selectedBusiness}
          disabled={isEmpty(businessList)}
        />
        <SCSelect
          searchable
          options={branches}
          customLabel={b => `${b.id}. ${b.title}`}
          searchAbleAttribute={['title', 'id']}
          trackBy="id"
          placeholder="Select a Branch"
          className="w-64"
          onSelect={onBranchSelected}
          value={selectedBranch}
          disabled={isEmpty(selectedBusiness)}
        />
      </div>
    </div>
  );
};

Filters.propTypes = {
  branches: PropTypes.array,
  businessList: PropTypes.array,
  getBranches: PropTypes.func,
  getBrands: PropTypes.func,
  getPrinterProfiles: PropTypes.func,
  selectedBranch: PropTypes.object,
  selectedBusiness: PropTypes.object,
  updateField: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  branches: makeSelectProperty('branches'),
  businessList: makeSelectGlobalProperty('businessList'),
  selectedBranch: makeSelectProperty('selectedBranch'),
  selectedBusiness: makeSelectProperty('selectedBusiness'),
});

const mapDispatchToProps = dispatch => ({
  getBranches: payload => dispatch(getList(payload)),
  getBrands: payload => dispatch(getList(payload)),
  getPrinterProfiles: payload => dispatch(getList(payload)),
  updateField: payload => dispatch(updateEntity(payload)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(Filters);
